import qs from 'query-string';
import { get } from './baseApi';

export const BuyerApi = {
    fetch: (query) => get(`/buyers?${qs.stringify(query)}`),
};
